/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRichContact } from './APIRichContact';
import {
    APIRichContactFromJSON,
    APIRichContactFromJSONTyped,
    APIRichContactToJSON,
} from './APIRichContact';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactGroupView
 */
export interface APIContactGroupView {
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupView
     */
    readonly self: string;
    /**
     * 
     * @type {Array<APIRichContact>}
     * @memberof APIContactGroupView
     */
    contacts: Array<APIRichContact>;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroupView
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroupView
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupView
     */
    name: string;
}

/**
 * Check if a given object implements the APIContactGroupView interface.
 */
export function instanceOfAPIContactGroupView(value: object): value is APIContactGroupView {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIContactGroupViewFromJSON(json: any): APIContactGroupView {
    return APIContactGroupViewFromJSONTyped(json, false);
}

export function APIContactGroupViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactGroupView {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contacts': ((json['contacts'] as Array<any>).map(APIRichContactFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APIContactGroupViewToJSON(value?: Omit<APIContactGroupView, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(APIRichContactToJSON)),
        'name': value['name'],
    };
}

